module.exports = __webpack_public_path__ + "static/jednatel.f193499e.jpg";